import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import DragAndDropHook from './drag-and-drop-hook';
import InfiniteScroll from './InfiniteScroll';
import Recursion from './Recursion';
import SharedHandleChange from './SharedHandleChange';
import StateDependOnEachOther from './StateDependOnEachOther';
import ToastSample from './ToastSample';
import UseBreakpointHook from './UseBreakpointHook';
import UseCallbackSample from './UseCallbackSample';
import UseMemoSample from './UseMemoSample';

const Tool: FC = () => {
  const { tool } = useParams();
  const components: { [key: string]: FC } = {
    'drag-and-drop-hook': DragAndDropHook,
    'infinite-scroll': InfiniteScroll,
    recursion: Recursion,
    'state-depend-on-each-other': StateDependOnEachOther,
    'shared-handle-change': SharedHandleChange,
    'toast-sample': ToastSample,
    'use-breakpoint-hook': UseBreakpointHook,
    'use-callback-sample': UseCallbackSample,
    'use-memo-sample': UseMemoSample,
    'not-found': NotFound,
  };
  const ComponentName = (tool && components[tool]) || components['not-found'];

  return <ComponentName />;
};

export default Tool;
